"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.array.concat.js");

var _emitter = _interopRequireDefault(require("element-ui/lib/mixins/emitter"));

var _migrating = _interopRequireDefault(require("element-ui/lib/mixins/migrating"));

var _merge = _interopRequireDefault(require("element-ui/lib/utils/merge"));

var _shared = require("element-ui/lib/utils/shared");

var _calcTextareaHeight = _interopRequireDefault(require("./calcTextareaHeight"));

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('div', {
    "class": [_vm.type === 'textarea' ? 'el-textarea' : 'el-input', _vm.inputSize ? 'el-input--' + _vm.inputSize : '', {
      'is-disabled': _vm.inputDisabled,
      'is-radius': _vm.radius,
      'el-input-group': _vm.$slots.prepend || _vm.$slots.append,
      'el-input-group--append': _vm.$slots.append,
      'el-input-group--prepend': _vm.$slots.prepend,
      'el-input--prefix': _vm.$slots.prefix || _vm.prefixIcon,
      'el-input--suffix': _vm.$slots.suffix || _vm.suffixIcon || _vm.clearable
    }],
    attrs: {},
    on: {
      "mouseenter": function mouseenter($event) {
        _vm.hovering = true;
      },
      "mouseleave": function mouseleave($event) {
        _vm.hovering = false;
      }
    }
  }, [_vm.type !== 'textarea' ? [_vm.$slots.prepend ? _c('div', {
    staticClass: "el-input-group__prepend",
    attrs: {}
  }, [_vm._t("prepend", null, {})], 2) : _vm._e(), _vm._v(" "), _vm.type !== 'textarea' ? _c('input', _vm._b({
    ref: "input",
    staticClass: "el-input__inner",
    attrs: {
      "tabindex": _vm.tabindex,
      "type": _vm.type,
      "disabled": _vm.inputDisabled,
      "readonly": _vm.readonly,
      "autocomplete": _vm.autoComplete,
      "aria-label": _vm.label
    },
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "compositionstart": _vm.handleComposition,
      "compositionupdate": _vm.handleComposition,
      "compositionend": _vm.handleComposition,
      "input": _vm.handleInput,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "change": _vm.handleChange,
      "keydown": function keydown($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "space", 32, $event.key, " ")) {
          return null;
        }

        return _vm.clearSpace($event);
      }
    }
  }, 'input', _vm.$attrs, false)) : _vm._e(), _vm._v(" "), _vm.$slots.prefix || _vm.prefixIcon ? _c('span', {
    staticClass: "el-input__prefix",
    attrs: {}
  }, [_vm._t("prefix", null, {}), _vm._v(" "), _vm.prefixIcon ? _c('i', {
    staticClass: "el-input__icon",
    "class": _vm.prefixIcon,
    attrs: {}
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _vm.$slots.suffix || _vm.suffixIcon || _vm.showClear || _vm.validateState && _vm.needStatusIcon ? _c('span', {
    staticClass: "el-input__suffix",
    attrs: {}
  }, [_c('span', {
    staticClass: "el-input__suffix-inner",
    attrs: {}
  }, [!_vm.showClear ? [_vm._t("suffix", null, {}), _vm._v(" "), _vm.suffixIcon ? _c('i', {
    staticClass: "el-input__icon",
    "class": _vm.suffixIcon,
    attrs: {},
    on: {
      "click": _vm.handleSuffixIconClick
    }
  }) : _vm._e()] : _c('i', {
    staticClass: "el-input__icon el-icon-circle-close el-input__clear",
    attrs: {},
    on: {
      "click": _vm.clear
    }
  })], 2), _vm._v(" "), _vm.validateState ? _c('i', {
    staticClass: "el-input__icon",
    "class": ['el-input__validateIcon', _vm.validateIcon],
    attrs: {}
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.$slots.append ? _c('div', {
    staticClass: "el-input-group__append",
    attrs: {}
  }, [_vm._t("append", null, {})], 2) : _vm._e()] : _c('textarea', _vm._b({
    ref: "textarea",
    staticClass: "el-textarea__inner",
    style: _vm._px2rem(_vm.textareaStyle, 24, []),
    attrs: {
      "tabindex": _vm.tabindex,
      "disabled": _vm.inputDisabled,
      "readonly": _vm.readonly,
      "aria-label": _vm.label
    },
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "compositionstart": _vm.handleComposition,
      "compositionupdate": _vm.handleComposition,
      "compositionend": _vm.handleComposition,
      "input": _vm.handleInput,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "change": _vm.handleChange
    }
  }, 'textarea', _vm.$attrs, false))], 2);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElInput',
  componentName: 'ElInput',
  mixins: [_emitter["default"], _migrating["default"]],
  inheritAttrs: false,
  inject: {
    elForm: {
      "default": ''
    },
    elFormItem: {
      "default": ''
    }
  },
  data: function data() {
    return {
      currentValue: this.value === undefined || this.value === null ? '' : this.value,
      textareaCalcStyle: {},
      hovering: false,
      focused: false,
      isOnComposition: false,
      valueBeforeComposition: null
    };
  },
  props: {
    value: [String, Number],
    size: String,
    resize: String,
    form: String,
    disabled: Boolean,
    readonly: Boolean,
    type: {
      type: String,
      "default": 'text'
    },
    autosize: {
      type: [Boolean, Object],
      "default": false
    },
    autoComplete: {
      type: String,
      "default": 'off'
    },
    validateEvent: {
      type: Boolean,
      "default": true
    },
    suffixIcon: String,
    prefixIcon: String,
    label: String,
    clearable: {
      type: Boolean,
      "default": false
    },
    tabindex: String,
    customAutoFocus: Boolean,
    // 扩展
    // 扩展 输入框不允许输入空格
    nospace: {
      type: Boolean,
      "default": false
    },
    // 扩展 圆角输入框
    radius: {
      type: Boolean,
      "default": false
    }
  },
  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    validateState: function validateState() {
      return this.elFormItem ? this.elFormItem.validateState : '';
    },
    needStatusIcon: function needStatusIcon() {
      return this.elForm ? this.elForm.statusIcon : false;
    },
    validateIcon: function validateIcon() {
      return {
        validating: 'el-icon-loading',
        success: 'el-icon-circle-check',
        error: 'el-icon-circle-close'
      }[this.validateState];
    },
    textareaStyle: function textareaStyle() {
      return (0, _merge["default"])({}, this.textareaCalcStyle, {
        resize: this.resize
      });
    },
    inputSize: function inputSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    inputDisabled: function inputDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    showClear: function showClear() {
      return this.clearable && !this.disabled && !this.readonly && this.currentValue !== '' && (this.focused || this.hovering);
    }
  },
  watch: {
    value: function value(val, oldValue) {
      this.setCurrentValue(val);
    }
  },
  methods: {
    focus: function focus() {
      ;
      (this.$refs.input || this.$refs.textarea).focus();
    },
    blur: function blur() {
      ;
      (this.$refs.input || this.$refs.textarea).blur();
    },
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          icon: 'icon is removed, use suffix-icon / prefix-icon instead.',
          'on-icon-click': 'on-icon-click is removed.'
        },
        events: {
          click: 'click is removed.'
        }
      };
    },
    handleBlur: function handleBlur(event) {
      this.focused = false;
      this.$emit('blur', event);

      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.blur', [this.currentValue]);
      }
    },
    select: function select() {
      ;
      (this.$refs.input || this.$refs.textarea).select();
    },
    resizeTextarea: function resizeTextarea() {
      if (this.$isServer) return;
      var autosize = this.autosize,
          type = this.type;
      if (type !== 'textarea') return;

      if (!autosize) {
        this.textareaCalcStyle = {
          minHeight: (0, _calcTextareaHeight["default"])(this.$refs.textarea).minHeight
        };
        return;
      }

      var minRows = autosize.minRows;
      var maxRows = autosize.maxRows;
      this.textareaCalcStyle = (0, _calcTextareaHeight["default"])(this.$refs.textarea, minRows, maxRows);
    },
    handleFocus: function handleFocus(event) {
      this.focused = true;
      this.$emit('focus', event);
    },
    handleComposition: function handleComposition(event) {
      if (event.type === 'compositionend') {
        this.isOnComposition = false;
        this.currentValue = this.valueBeforeComposition;
        this.valueBeforeComposition = null;
        this.handleInput(event);
      } else {
        var text = event.target.value;
        var lastCharacter = text[text.length - 1] || '';
        this.isOnComposition = !(0, _shared.isKorean)(lastCharacter);

        if (this.isOnComposition && event.type === 'compositionstart') {
          this.valueBeforeComposition = text;
        }
      }
    },
    handleInput: function handleInput(event) {
      var value = event.target.value;
      this.setCurrentValue(value);
      if (this.isOnComposition) return;
      this.$emit('input', value);
    },
    handleChange: function handleChange(event) {
      this.$emit('change', event.target.value);
    },
    setCurrentValue: function setCurrentValue(value) {
      if (this.isOnComposition && value === this.valueBeforeComposition) return;
      this.currentValue = value;
      if (this.isOnComposition) return;
      this.$nextTick(this.resizeTextarea);

      if (this.validateEvent && this.currentValue === this.value) {
        this.dispatch('ElFormItem', 'el.form.change', [value]);
      }
    },
    calcIconOffset: function calcIconOffset(place) {
      var elList = [].slice.call(this.$el.querySelectorAll(".el-input__".concat(place)) || []);
      if (!elList.length) return;
      var el = null;

      for (var i = 0; i < elList.length; i++) {
        if (elList[i].parentNode === this.$el) {
          el = elList[i];
          break;
        }
      }

      if (!el) return;
      var pendantMap = {
        suffix: 'append',
        prefix: 'prepend'
      };
      var pendant = pendantMap[place];

      if (this.$slots[pendant]) {
        el.style.transform = "translateX(".concat(place === 'suffix' ? '-' : '').concat(this.$el.querySelector(".el-input-group__".concat(pendant)).offsetWidth, "px)");
      } else {
        el.removeAttribute('style');
      }
    },
    updateIconOffset: function updateIconOffset() {
      this.calcIconOffset('prefix');
      this.calcIconOffset('suffix');
    },
    clear: function clear() {
      this.$emit('input', '');
      this.$emit('change', '');
      this.$emit('clear');
      this.setCurrentValue('');
      this.focus();
    },
    // 扩展 输入框不允许输入空格
    clearSpace: function clearSpace(event) {
      if (this.nospace) {
        event.returnValue = false;
      }
    },
    handleSuffixIconClick: function handleSuffixIconClick() {
      this.$emit('suffix-icon-click');
    }
  },
  created: function created() {
    this.$on('inputSelect', this.select);
  },
  mounted: function mounted() {
    this.resizeTextarea();
    this.updateIconOffset();
  },
  updated: function updated() {
    this.$nextTick(this.updateIconOffset);
  }
};
exports["default"] = _default;